import { useQuery, useQueryClient } from "react-query"
import api from "../utils/axios"

// ---- contratos do backend (data-credits.ts / utils/credits.ts) --------------
export interface LedgerEntry {
    id: number
    delta: number
    reason: string
    ref_type: string | null
    ref_id: number | null
    balance_after: number
    createdat: string
}

export interface WalletResponse {
    balance: number
    /** Preço unitário do crédito (R$). Ausente em backends antigos. */
    unit_price?: number
    ledger: LedgerEntry[]
}

export const WALLET_QUERY_KEY = ["wallet"] as const

/**
 * Carteira de créditos do provedor, compartilhada entre o header (saldo) e a
 * página /credits (saldo + extrato). Uma única query; quem gasta ou compra
 * crédito chama `invalidateWallet()` para o header refletir na hora.
 */
export function useWallet(enabled = true) {
    return useQuery<WalletResponse, Error>(
        WALLET_QUERY_KEY,
        async () => {
            const res = await api.post<WalletResponse>("/credits/wallet", {})
            return res.data
        },
        { enabled, staleTime: 30_000 }
    )
}

export function useInvalidateWallet() {
    const qc = useQueryClient()
    return () => qc.invalidateQueries(WALLET_QUERY_KEY)
}
